import { CompanyStatusEnum } from "../../enums/company-status.enum";

export class SearchMemberCompanyModel { 
    public name: string = '';
    public asc: boolean = true;  
    public city: string = '';
    public status : number = CompanyStatusEnum.All;
    public pageSize: number = 10;
    public pageNumber: number = 1;
}